import AttributeEditorTable, {
  AttributeConfiguration,
} from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/Panels/AttributeEditorTable';
import { ProductFeatureName } from 'dashboard/models/organization';
import { CaseInfoAttribute, ModuleCaseInfo } from 'dashboard/modules/CaseInfo';
import useProductFeature from 'lib/hooks/useProductFeature';

export interface CaseInfoPanelProps {
  module: ModuleCaseInfo;
  updateModule: (module: ModuleCaseInfo) => void;
}

const CaseInfoPanel = ({ module, updateModule }: CaseInfoPanelProps) => {
  const updateAttributes = (attributes: CaseInfoAttribute[]) => {
    updateModule({ ...module, attributes });
  };
  const hasCasesEnhanced = useProductFeature(ProductFeatureName.CasesEnhanced);
  const hasCasesEnterprise = useProductFeature(ProductFeatureName.CasesEnterprise);

  const attributes: AttributeConfiguration<CaseInfoAttribute>[] = [
    {
      label: 'Assignee',
      key: 'assignee',
      display: true,
    },
    {
      label: 'Reference IDs',
      key: 'reference-ids',
      display: true,
    },
    {
      label: 'Accounts',
      key: 'accounts',
      display: true,
    },
    {
      label: 'Deadline',
      key: 'sla',
      display: hasCasesEnhanced || hasCasesEnterprise,
    },
    {
      label: 'Created at',
      key: 'created-at',
      display: true,
    },
    {
      label: 'Updated at',
      key: 'updated-at',
      display: true,
    },
  ];

  return (
    <AttributeEditorTable<CaseInfoAttribute>
      allAttributes={attributes}
      moduleAttributes={module.attributes}
      updateAttributes={updateAttributes}
    />
  );
};

export default CaseInfoPanel;
